const Footer =()=>{
    return(
        <footer className="footer" id="footer">
            <div className="container">
                <p className="colophon text-center">Site by <a className="site-link" href="https://jmscoding100.github.io/-Portfolio/" target="_blank">Joshua McGee</a></p>
            </div>
        </footer>
    )
}

export default Footer